/**
 * Per-device default workspace (Practice). Stored in localStorage so the app
 * can land in the right workspace on open without a round-trip; scoped per
 * user id so shared machines don't leak one user's choice into another's
 * session. Holds the org id (stable) rather than the slug (renameable).
 */
const KEY_PREFIX = 'clinikchat.defaultOrgId.';

function storageKey(userId: string): string {
  return `${KEY_PREFIX}${userId}`;
}

export function getDefaultOrgId(userId: string | undefined): string | null {
  if (!userId) return null;
  try {
    return localStorage.getItem(storageKey(userId));
  } catch {
    return null;
  }
}

export function setDefaultOrgId(userId: string | undefined, orgId: string | null): void {
  if (!userId) return;
  try {
    if (orgId === null) {
      localStorage.removeItem(storageKey(userId));
    } else {
      localStorage.setItem(storageKey(userId), orgId);
    }
  } catch {
    // Storage unavailable (private mode / quota) — the picker still works,
    // the preference just won't persist.
  }
}
